import { Component, EventEmitter, Output, input, signal, effect } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

@Component({
  selector: 'app-kiosk-pager-atom',
  templateUrl: './kiosk-pager-atom.component.html',
})
export class KioskPagerAtomComponent {
  readonly color = input<IContentBuilderFieldColor>();
  readonly value = input.required<string>();
  readonly pagerSize = input.required<number>();
  readonly minPagerSize = input<number>();

  @Output() valueEmitter = new EventEmitter<string | boolean>();

  pagerValue = signal(''); // use linkedSignal once available to avoid the effect

  constructor() {
    effect(
      () => {
        if (this.value()) {
          this.pagerValue.set(this.value());
        }
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  onNumberClick(value: number | string): void {
    const valueStr = value.toString();
    if (this.pagerValue().length < (this.minPagerSize() ?? this.pagerSize())) {
      this.pagerValue.set(this.pagerValue() + valueStr);
      this.onInputChange();
    }
  }

  onDeleteClick(): void {
    this.pagerValue.set('');
    this.emitValue();
  }

  onInputChange(): void {
    if (this.pagerValue().length === (this.minPagerSize() ?? this.pagerSize())) {
      this.emitValue();
    }
  }

  emitValue(): void {
    this.valueEmitter.emit(this.pagerValue());
  }
}
